var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7203 16.2565L4.4531 12.214L3 13.5809L8.7203 19L21 7.36689L19.5571 6L8.7203 16.2565Z",
    fill: "#57689F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.0d92f733917d765581e422f43501dab8.svg";
export { ForwardRef as ReactComponent };